module.exports = __webpack_public_path__ + "img/webShare.646d567b.jpg";